/* eslint-disable no-undef */
export default {
	name: "fuel-dispensement-validation",
	props: ["collectionCode", "vehicleRegistration"],
	emits: ["validationCompleted"],
	data() {
		return {
			orderInfoToValidation:{
				orderNumber: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				vehicleRegistration: {
					value: null,
					hasError: false,
					errorMessage: null
				}
			},
			successMessage:{
				message: "Fuel dispensement validated successfully.",
				showSuccessMessage: false
			},
			errorMessage:{
				message: "Fuel dispensement validation failed.",
				showErrorMessage: false
			},
			loading: false,
			loadingFromApi: false
		};
	},
	methods: {
		validateFuelDispensement() {
			this.loading = true;
			this.loadingFromApi = true;
			
			let request = {
				collectionCode: this.orderInfoToValidation.orderNumber.value,
				vehicleRegistration: this.orderInfoToValidation.vehicleRegistration.value
			};
			orderService.verifyOrderCollectionByCollectionCode(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if (isSuccess) {
						if (successResponse.data.verifyOrderCollectionByCollectionCodeValidationResponse.valuesAreValid) {
							this.$emit("validationCompleted", {
								isValid: successResponse.data.canDispenseOrder,
								orderNumber: this.orderInfoToValidation.orderNumber.value,
								vehicleRegistration: this.orderInfoToValidation.vehicleRegistration.value,
								orderCollection: successResponse.data.orderCollection,
								orderItems: successResponse.data.orderItems
							});
						}
						else {
							this.orderInfoToValidation.orderNumber.hasError = successResponse.data.verifyOrderCollectionByCollectionCodeValidationResponse.collectionCodeValidationResponse.hasError;
							this.orderInfoToValidation.orderNumber.errorMessage = successResponse.data.verifyOrderCollectionByCollectionCodeValidationResponse.collectionCodeValidationResponse.message;

							this.orderInfoToValidation.vehicleRegistration.hasError = successResponse.data.verifyOrderCollectionByCollectionCodeValidationResponse.vehicleRegistrationValidationResponse.hasError;
							this.orderInfoToValidation.vehicleRegistration.errorMessage = successResponse.data.verifyOrderCollectionByCollectionCodeValidationResponse.vehicleRegistrationValidationResponse.message;
						}
					}
					this.loading = false;
					this.loadingFromApi = false;
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					this.showErrorMessage = true;
					this.errorMessage = errorResponse.response.data.message;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
					this.loading = false;
					this.loadingFromApi = false;
				}
			);
		},
		clearMessageAlerts(){
			//this.clearModel();
			this.successMessage ={
				message: "Fuel dispensement validated successfully.",
				showSuccessMessage: false
			};
			this.errorMessage = {
				message: "Fuel dispensement validation failed.",
				showErrorMessage: false
			};
		},
	},
	mounted: function () {
	},
	watch: {
		collectionCode:{
			handler: function () {
				console.log("collectionCode", this.collectionCode);
				if (this.collectionCode !== null && this.collectionCode !== "") {
					this.orderInfoToValidation.orderNumber.value = this.collectionCode;
				}
			},
			immediate: true,
			deep: true
		},
		vehicleRegistration:{
			handler: function () {
				console.log("vehicleRegistration", this.vehicleRegistration);
				if (this.vehicleRegistration !== null && this.vehicleRegistration !== "") {
					this.orderInfoToValidation.vehicleRegistration.value = this.vehicleRegistration;
				}
			},
			immediate: true,
			deep: true
		}
	}
};